import { routes } from '@/constants/Constants';
import { lazyComponent } from '@/shared/utils/router.util';

const { ZgriDashboardRoute } = lazyComponent(
  () => import('./routes/zgri-dashboard.route'),
  'ZgriDashboardRoute',
);

export const zgriNavigationPath = routes.rentersInsurance;

export const zgriRoutes = [
  {
    path: routes.rentersInsurance,
    component: ZgriDashboardRoute,
    title: 'Renters Insurance | TheGuarantors',
  },
];
